<template>
	<div class="bind_frm">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">绑定FRM</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			终端与项目/人员组进行关联[绑定]，关联[绑定]后可实现云端人员数据同步。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (BOOL)skFaceBindFRMWithCode:(NSString *)bindCode bindFRMCallBack:(BindFRMCallBack)bindFRMCallBack;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）bindCode：FRM绑定码</p>
        <p class="doc_main_p">（2）bindFRMCallback：绑定FRM的结果回调接口</p>
        
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	（1）BOOL类型，true表示成功，可处理回调结果；false表示失败（绑定码格式有误），无需处理回调（回调不返回信息）。
		</p>
		<p class="doc_main_p">
        	（2）bindFRMCallback(int code, NSString * msg)：code错误码，0为成功，其他失败；msg：错误消息。
		</p>
		<h3 class="doc_main_h3">错误码列表</h3>
		<get-frm-bind-code-error-list :propsTableData="errorCodeList"></get-frm-bind-code-error-list>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">BOOL result = [SKFaceManagerInterface skFaceBindFRMWithCode:
	@"绑定码信息" bindFRMCallBack:^(int code, NSString *msg) {
        //绑定成功，处理绑定结果
        if (code == 0) {
        }
}];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import GetFRMBindCodeErrorList from '../../../../components/getFRMBindCodeErrorList';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'get-frm-bind-code-error-list':GetFRMBindCodeErrorList,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','FRM接口','绑定FRM'],
				errorCodeList:[
					{"code":"0","msg":"成功"},
					{"code":"10003","msg":"要绑定的分组不存在"},
					{"code":"10005","msg":"项目已经锁定"},
					{"code":"20004","msg":"域名错误"},
					{"code":"20005","msg":"HTTP链接服务器错误"},
					{"code":"20006","msg":"HTTPS链接服务器错误"},
					{"code":"20007","msg":"SOCKET超时"},
					{"code":"20022","msg":"编码格式有误"},
					{"code":"20024","msg":"DNS解析错误"},
					
				]
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.bind_frm{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/frm/bindFRM.vue